import { combineReducers } from "@reduxjs/toolkit";
import inputReducer from "./scenes/Input/input.slice";
import outputReducer from "./scenes/Output/output.slice";

const rootReducer = combineReducers({
  input: inputReducer,
  output: outputReducer,
});

export default rootReducer;
